"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenForOption = void 0;
var andThen_1 = require("./andThen");
function flatten(input) {
    return input;
}
/**
 *  Flatten the inner value of _input_.
 */
function flattenForOption(input) {
    var result = (0, andThen_1.andThenForOption)(input, flatten);
    return result;
}
exports.flattenForOption = flattenForOption;
